import React from 'react';
import { classCombine } from 'Utils/Utils';
import './PageTitle.css';

const PageTitle = ({ text, alignText = 'left', privacyMaskTitle, modernLayout, customClass = '' }) => {
  return (
    <div
      className={`pageTitleContainer ${modernLayout && 'modernLayout'}`}
      data-dd-privacy={privacyMaskTitle ? 'mask' : ''}
    >
      <h1 className={classCombine('pageTitle', alignText, customClass)}>{text}</h1>
    </div>
  );
};

export default PageTitle;
